<template>
  <ParagraphBody
    v-if="releaseLabelText.length > 0"
    bodySize="small"
    :class="[
      $style.label,
      getReleaseStatusLabelStyle
    ]"
    weigth="light"
  >
    {{ releaseLabelText }}
  </ParagraphBody>
</template>

<script>
import { DeviceSupportedOSLabels } from 'client/util/Constants';
import {
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import OsManagementMixin from 'client/OsManagement/mixins/OsManagementMixin';

const { windows, macos } = DeviceSupportedOSLabels;
const Ubuntu = 'Ubuntu';

export default {
  name: 'ReleaseStatusLabel',

  components: {
    ParagraphBody,
  },

  mixins: [OsManagementMixin],

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    ...mapState('OsReleasesPatchesModule', ['osVersionPatchList']),

    getReleaseStatusLabelStyle() {
      let style = '';
      if (this.releaseLabelType === 'endOfService') {
        style = this.$style.endOfService;
      } else if (this.releaseLabelType === 'nearEndOfService') {
        style = this.$style.nearEndOfService;
      }
      return style;
    },

    isDeviceOverviewEndOfServiceActive() {
      return this.$hasFeatureFlag(this.$featureFlags.deviceOverviewEndOfService);
    },

    releaseLabel() {
      const { name, fullVersion } = this.item;
      const osVersionParts = fullVersion.split(';');

      const releaseTag = {
        label: '',
        type: 'latest',
      };

      // Darwin
      if (name.includes(macos)) {
        releaseTag.label = this.osVersionPatchList?.MacOS?.some((releaseOs) => releaseOs.build === osVersionParts[3]) ? 'LATEST' : '';

        if (releaseTag.label === '' && this.isDeviceOverviewEndOfServiceActive) {
          const majorOSVersion = osVersionParts[2].split('.');
          const latestOsVersionParts = this.osVersionPatchList.MacOS[0]?.version?.split('.');

          if ((Number(latestOsVersionParts[0]) - 2) > Number(majorOSVersion[0])) {
            releaseTag.type = 'endOfService';
            releaseTag.label = 'END OF SERVICE';
          }
        }
      }

      // Windows
      if (name.includes(windows)) {
        const buildNumber = String(osVersionParts[2]).split('.')[2];
        // eslint-disable-next-line
        releaseTag.label = this.osVersionPatchList?.Windows?.some((releaseOs) => releaseOs.version+"."+releaseOs.build === buildNumber+"."+osVersionParts[3]) ? 'LATEST' : '';

        if (releaseTag.label === '' && this.isDeviceOverviewEndOfServiceActive) {
          const { days } = this.getEndOfServiceDate(windows, this.item.fullVersion);

          if (days >= -90 && days <= 0) {
            releaseTag.label = 'NEAR END OF SERVICE';
            releaseTag.type = 'nearEndOfService';
          } else if (days > 0) {
            releaseTag.label = 'END OF SERVICE';
            releaseTag.type = 'endOfService';
          }
        }
      }

      // Linux
      if (name.includes(Ubuntu)) {
        releaseTag.label = this.osVersionPatchList.Ubuntu
          .some((releaseOs) => {
            let matchingVersion = true;
            const version = osVersionParts[2].slice(0, -1);

            if (releaseOs.version !== version) {
              // this is necessary because the system's os versions are not 0 padded,
              // which conflicts with the Ubuntu versions. Once fixed, this can be deleted.
              const releaseOsVersionParts = releaseOs.version.split('.');
              const versionParts = version.split('.');

              for (let i = 0; i < releaseOsVersionParts.length; i += 1) {
                if (parseInt(releaseOsVersionParts[i], 10) !== parseInt(versionParts[i], 10)) {
                  matchingVersion = false;
                  break;
                }
              }
            }
            return matchingVersion;
          });

        if (releaseTag.label) {
          releaseTag.label = 'LATEST';
        }
      }

      return releaseTag;
    },

    releaseLabelText() {
      return this.releaseLabel.label;
    },

    releaseLabelType() {
      return this.releaseLabel.type;
    },
  },

};
</script>
<style module scoped>
.label {
  background: var(--jcSuccess100);
  border-radius: 4px;
  display: inline-block;
  font-size: var(--jcBodyTiny);
  margin: 0;
  padding: var(--jc-spacer-x-small) var(--jc-spacer-small);
  text-align: center;
}

.nearEndOfService {
  background: var(--jcWarning100);
}

.endOfService {
  background: var(--jcError100);
}
</style>
